import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as serviceActions from "../../actions/serviceActions";
import * as departmentActions from "../../actions/departmentActions";
import * as codeActions from "../../actions/codeActions";
import * as modalActions from "../../actions/modalActions";

import ServiceList from "./ServiceList";
import HeaderWrapper from "../common/HeaderWrapper";

class ServicePage extends Component {
  constructor(props) {
    super(props);
    this.state = { service: {}, open: false, adding: false, search: "" };
  }

  componentDidMount = () => {
    const { departments, actions } = this.props;
    if (!departments.length) actions.loadDepartments();

    actions.loadServices();
  };

  onClickAdd = () => {
    this.props.history.push("/app/settings/services/add");
  };

  onClickEdit = (service) => {
    this.props.actions.getService(service.id, true);
  };

  handleAdd = (service) => {
    this.props.actions.createService(service);
  };

  handleSave = (service) => {
    this.props.actions.updateService(service);
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { services } = this.props;
    const { search } = this.state;

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[
            { label: "Settings" },
            { label: "Service Descriptions" }
          ]}
          onClickAdd={this.onClickAdd}
        />
        <div className="content-wrapper">
          <ServiceList
            services={services}
            search={search}
            onClickEdit={this.onClickEdit}
          />
        </div>
      </>
    );
  }
}

ServicePage.propTypes = {
  actions: PropTypes.object,
  departments: PropTypes.array,
  services: PropTypes.array.isRequired,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    services: state.reducers.services,
    departments: state.reducers.departments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...serviceActions,
        ...departmentActions,
        ...codeActions,
        ...modalActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ServicePage);
